import { cn } from '@seen/ui'
import { type ComponentProps, forwardRef } from 'react'

export interface TextareaProps extends Omit<
  ComponentProps<'textarea'>,
  'onChange'
> {
  onChange?: (value: string) => void
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ onChange, className, ...delegated }, ref) => (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      ref={ref}
      onChange={(event) => onChange?.(event.target.value)}
      {...delegated}
    />
  )
)

Textarea.displayName = 'Textarea'
